import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

function Footer({ appState }) {
    
    console.log("FFFFFFFFFFFFFFF ",appState)
  const studio = {
    name: appState?.adminDetails?.companyName,
    address: appState?.adminDetails?.address,
    phone:  appState?.adminDetails?.phone,
    email: appState?.adminDetails?.email,

    social: {
      instagram: appState?.adminDetails?.socialLinks?.instagram,
      facebook: appState?.adminDetails?.socialLinks?.facebook,
      youtube: appState?.adminDetails?.socialLinks?.youtube,
    },
  };

  return (
    <footer className="bg-gray-950 text-gray-300 mt-10">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-10 text-left">
        {/* Studio Details */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">
            {studio.name}
          </h2>

          <div className="space-y-3 text-sm">
            <div className="flex items-start gap-3 ">
              <FaMapMarkerAlt className="mt-1 text-yellow-500" />
              <span>{studio.address}</span>
            </div>

            <div className="flex items-center gap-3">
              <FaPhoneAlt className="text-yellow-500" />
              <a
                href={`tel:${studio.phone}`}
                className="hover:text-white transition"
              >
                {studio.phone}
              </a>
            </div>

            <div className="flex items-center gap-3">
              <FaEnvelope className="text-yellow-500" />
              <a
                href={`mailto:${studio.email}`}
                className="hover:text-white transition"
              >
                {studio.email}
              </a>
            </div>
          </div>
        </div>

        
        {/* Social Media */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4 text-left">
            Follow Us on Social Media Links
          </h3>

          <div className="flex gap-4">
            <a
              href={studio.social.instagram}
              target="_blank"
              rel="noreferrer"
              className="w-11 h-11 rounded-full bg-gray-800 flex items-center justify-center hover:bg-pink-600 transition"
            >
              <FaInstagram size={20} />
            </a>

            <a
              href={studio.social.facebook}
              target="_blank"
              rel="noreferrer"
              className="w-11 h-11 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition"
            >
              <FaFacebookF size={18} />
            </a>

            <a
              href={studio.social.youtube}
              target="_blank"
              rel="noreferrer"
              className="w-11 h-11 rounded-full bg-gray-800 flex items-center justify-center hover:bg-red-600 transition"
            >
              <FaYoutube size={20} />
            </a>
                  </div>
                  
              </div>
              

                <p className="mt-2 md:mt-0 text-lg md:text-2xl mt-8">
                  Designed with ❤️ by <span className="text-yellow-400">{appState?.adminDetails?.companyName}</span>
          </p>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-5 mb-20 flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
          <p>
            © {new Date().getFullYear()} {studio.name}. All Rights Reserved.
          </p>

        
        </div>
      </div>
    </footer>
  );
}

export default Footer;